import { render, staticRenderFns } from "./ThreadRoom.vue?vue&type=template&id=3ffe0ebc&scoped=true"
import script from "./ThreadRoom.vue?vue&type=script&lang=js"
export * from "./ThreadRoom.vue?vue&type=script&lang=js"
import style0 from "./ThreadRoom.vue?vue&type=style&index=0&id=3ffe0ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffe0ebc",
  null
  
)

export default component.exports